import React from "react";
import { Box, Flex, Text } from "@radix-ui/themes";
import * as ReactAccordion from "@radix-ui/react-accordion";
import { ChevronDownIcon } from "@radix-ui/react-icons";

import style from "./Accordion.module.css";

interface AccordionProps {
  content: { body: string; heading: string }[];
  id?: string;
  isLast?: boolean;
  isFirst?: boolean;
}

const AccordionTrigger = React.forwardRef<
  HTMLButtonElement,
  React.ComponentPropsWithoutRef<typeof ReactAccordion.Trigger>
>(({ children, className, ...props }, forwardedRef) => (
  <ReactAccordion.Header className={style.AccordionHeader}>
    <ReactAccordion.Trigger
      className={style.AccordionTrigger}
      {...props}
      ref={forwardedRef}
    >
      {children}
      <ChevronDownIcon className={style.AccordionChevron} aria-hidden />
    </ReactAccordion.Trigger>
  </ReactAccordion.Header>
));

const AccordionContent = React.forwardRef<
  HTMLDivElement,
  React.ComponentPropsWithoutRef<typeof ReactAccordion.Content>
>(({ children, className, ...props }, forwardedRef) => (
  <ReactAccordion.Content
    className={style.AccordionContent}
    {...props}
    ref={forwardedRef}
  >
    <div className={style.AccordionContentText}>{children}</div>
  </ReactAccordion.Content>
));

AccordionTrigger.displayName = "AccordionTrigger";
AccordionContent.displayName = "AccordionContent";

const Accordion: React.FC<AccordionProps> = ({
  content,
  id,
  isLast,
  isFirst,
}) => (
  <Box
    id={id}
    mt={isFirst ? "0" : "8"}
    mb={isLast ? "0" : "8"}
    style={{
      scrollMarginTop: "90px",
    }}
  >
    <ReactAccordion.Root
      className={style.AccordionRoot}
      collapsible
      defaultValue="item-0"
      type="single"
    >
      {content.map((item, index) => {
        return (
          <ReactAccordion.Item
            className={style.AccordionItem}
            value={`item-${index}`}
            key={index}
          >
            <AccordionTrigger>
              <Flex gap="2" width="90%">
                <Text>{`${Number(index) + 1}.`}</Text>
                <Text>{item.heading}</Text>
              </Flex>
            </AccordionTrigger>
            <AccordionContent>{item.body}</AccordionContent>
          </ReactAccordion.Item>
        );
      })}
    </ReactAccordion.Root>
  </Box>
);

export default Accordion;
